import gql from 'graphql-tag';
import { AdminDonationItem } from '../fragments';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';

export default gql`
query donations($filters: AdminDonationsFilter, $sortBy: AdminDonationsOrder, $count: Int!, $page: Int) {
    donations(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...AdminDonationItem
        }
    }
}
${PaginatorInfoFragment}
${AdminDonationItem}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/donations.ts